import { TState } from '@r1-frontend/entities/stores/auth/reducer';

export const selectIsAuth = (state: TState) => {
    return state.auth.isAuth;
};
